import React from 'react';
import Detail from './Detail';
import {FieldArray} from 'formik';
import Button from 'src/components/button';
import PropTypes from 'prop-types';
import styles from './Details.module.scss';

const initialDetailValues = {
  _id: null,
  _type: 'TimeSensitiveItemType::ShortTextDetail',
  question: null,
  required: false,
};

const propTypes = {
  details: PropTypes.array,
};

const Details = (props) => {
  const {details} = props;
  return (
    <div className={styles.detailsSectionBorder}>
      <h3>Details Section</h3>
      <FieldArray
        name="details"
        render={(arrayHelpers) => (
          <div>
            {details &&
              details.length > 0 &&
              details.map((detail, index) => (
                <Detail
                  detail={detail}
                  key={index}
                  index={index}
                  removeDetail={() => arrayHelpers.remove}
                />
              ))}
            <Button
              aria-label="Add detail"
              size="small"
              className={styles.addField}
              onClick={() => arrayHelpers.push(initialDetailValues)}
            >
              + Additional detail
            </Button>
          </div>
        )}
      />
    </div>
  );
};

Details.propTypes = propTypes;
export default Details;
